// react
import React, { useRef, useState } from 'react'
// constants (data | images)
import { howItWorksImages } from "../../../../constants/images"
import { howItWorks } from "../../../../constants/data";
import { Heading } from "../../../../components/UI";

// FC: HowItWorks Component
const HowItWorks = () => {
  // State
  const [currentImage, setCurrentImage] = useState(0);
  // Ref
  const howItWorksRef = useRef<HTMLElement | null>(null);

  // does: scroll to top
  const scrollToTop = () => {
    if (window.innerWidth <= 600 && howItWorksRef.current) {
      howItWorksRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };


  // component return
  return (
    <main className="how-it-works | p-3 bg-white-800" ref={howItWorksRef}>
      <section className="| my-container flex-col gap-component">
        <Heading className="text-primary-400">How It Works?</Heading>
        <div className="how-it-works-container">
          <img loading="lazy" src={howItWorksImages[currentImage]} alt="how-it-works" style={{ maxHeight: "650px" }} />
          <ul className="| flex-col-center gap-1">
            {howItWorks.length > 0 && howItWorks.map((item, index) => {
              return (
                <li
                  key={item.heading}
                  className={`how-it-works-item | flex gap-1 bg-white-900 text-neutral-900 br-4 py-1 px-20 pointer shadow-small ${index === currentImage ? "active" : ""}`}
                  onClick={() => {
                    setCurrentImage(index);
                    scrollToTop();
                  }}>
                  <span className="how-it-works-number | p-1 fs-list-item-heading fw-600 circle bg-white-600">{index + 1}</span>
                  <div className="| flex-col gap-8">
                    <span className="| fs-list-item-heading fw-600">{item.heading}</span>
                    <p className="| m-0 fs-list-item-text fw-400">{item.description}</p>
                  </div>
                </li>
              )
            })}
          </ul>
        </div>
      </section>
    </main>
  )
}

export default HowItWorks